import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { Button } from "../ui/button";
import { ArrowLeft, Plus } from "lucide-react";
import { BasicInfo } from "./BasicInfo";
import { ReelsModule } from "./ReelsModule";
import { ClassroomModule } from "./ClassroomModule";
import { InMarketTable } from "./InMarketTable";
import { MockupTable } from "./MarkupTable";
import { useNavigate, useParams } from "react-router-dom";

interface ModuleEditorProps {
  moduleId?: string;
  isAdmin?: boolean;
}

export function ModuleEditor({ moduleId, isAdmin = false }: ModuleEditorProps) {
  const [activeTab, setActiveTab] = useState("basic-info");
  const navigate = useNavigate();
  
  console.log('ModuleEditor rendered with moduleId:', moduleId);

  const isEditing = moduleId !== undefined;

  const handleBack = () => {
    navigate("/modules");
  };

  const handleBasicInfoSave = (data: any) => {
    // Update the moduleId in the URL if it's a new module
    if (!moduleId && data.id) {
      navigate(`/modules/${data.id}/edit`, { replace: true });
    }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <span
            onClick={handleBack}
            className="cursor-pointer p-2 rounded hover:bg-gray-200 transition-colors"
            title="Back"
          >
            <ArrowLeft className="h-6 w-6" />
          </span>
          <h1 className="text-3xl font-bold">
            {isEditing ? "Edit Module" : "Create New Module"}
          </h1>
        </div>
        {isAdmin && (
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            Add Sub Module
          </Button>
        )}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Module Configuration</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-5">
              <TabsTrigger value="basic-info">Basic Info</TabsTrigger>
              <TabsTrigger value="reels">Reels</TabsTrigger>
              <TabsTrigger value="classroom">Classroom Training</TabsTrigger>
              <TabsTrigger value="inmarket">In Market</TabsTrigger>
              <TabsTrigger value="markup">Mockup</TabsTrigger>
            </TabsList>
            
            <TabsContent value="basic-info" className="mt-6">
              <BasicInfo 
                moduleId={moduleId} 
                onSave={handleBasicInfoSave}
              />
            </TabsContent>
            
            <TabsContent value="reels" className="mt-6">
              <ReelsModule moduleId={moduleId} onSave={(data) => {
                console.log("Saving reels:", data);
              }} />
            </TabsContent>
            
            <TabsContent value="classroom" className="mt-6">
              <ClassroomModule moduleId={moduleId} onSave={(data) => {
                console.log("Saving classroom:", data);
              }} />
            </TabsContent>
            
            <TabsContent value="inmarket" className="mt-6">
              <InMarketTable moduleId={moduleId} isActive={activeTab === "inmarket"} />
            </TabsContent>
            
            <TabsContent value="markup" className="mt-6">
              <MockupTable moduleId={moduleId} isActive={activeTab === "markup"} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
} 